<div class="payment-reports">
  <div class="page-header">
    <h1>Reports</h1>
    <app-reports-nav></app-reports-nav>
  </div>

  <!-- Every filter the run uses lives here. Office and User used to sit above the tabs while
       the date range and Run sat inside each tab, which read as two unrelated controls: the
       top pair looked inert because nothing re-ran until you scrolled down and pressed Run. -->
  <mat-card class="filter-card">
    <div class="filter-row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Department</mat-label>
        <mat-select [(ngModel)]="officeId" (selectionChange)="onOfficeChange()">
          <mat-option value="">Department (all)</mat-option>
          @for (o of offices; track o.id) { <mat-option [value]="o.id">{{ o.name }}</mat-option> }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>User (cashier)</mat-label>
        <mat-select [(ngModel)]="cashierUserId">
          <mat-option value="">All users</mat-option>
          @for (c of cashierOptions; track c.id) {
            <mat-option [value]="c.id">{{ c.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (isBalancing) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-date"><mat-label>Business date</mat-label>
          <input matInput [matDatepicker]="balancingPicker" [(ngModel)]="balancingDate"
                 (click)="balancingPicker.open()" readonly>
          <mat-datepicker-toggle matIconSuffix [for]="balancingPicker"></mat-datepicker-toggle>
          <mat-datepicker #balancingPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic"><mat-label>Group by</mat-label>
          <mat-select [(ngModel)]="groupBy">
            <mat-option value="drawer">Drawer</mat-option>
            <mat-option value="user">User</mat-option>
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-range"><mat-label>Date range</mat-label>
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Start" [(ngModel)]="rangeStart">
            <input matEndDate placeholder="End" [(ngModel)]="rangeEnd">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker></mat-date-range-picker>
        </mat-form-field>
      }

      <button mat-flat-button color="primary" class="run-btn" (click)="run()" [disabled]="loading">
        <mat-icon>play_arrow</mat-icon> Run
      </button>
    </div>
    <p class="hint" *ngIf="!cashierOptions.length">No active users in this department.</p>
  </mat-card>

  @if (error) { <div class="error-banner">{{ error }}</div> }
  @if (loading) { <mat-progress-bar mode="indeterminate"></mat-progress-bar> }

  <mat-tab-group [(selectedIndex)]="activeTab">
    <mat-tab label="Summary">
      <div class="tab-body"><app-summary-tab [report]="summary"></app-summary-tab></div>
    </mat-tab>

    <mat-tab label="Detailed">
      <div class="tab-body"><app-detailed-tab [report]="summary" [detail]="detail"></app-detailed-tab></div>
    </mat-tab>

    <mat-tab label="Daily balancing">
      <div class="tab-body"><app-balancing-tab [report]="balancing"></app-balancing-tab></div>
    </mat-tab>
  </mat-tab-group>
</div>
